<template>
    <div class="form-label">Загрузка документов</div>
    <div class="file-input-group">
        <input type="text" name="" id="upload-input" class="form-control file-input-group__input" v-model="file"
               placeholder="Документы форматов pdf xlsx csv ... ">
        <button class=" reset-btn file-input-group__reset" @click.prevent="clearInput">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.9992 7.94095L12.8616 13.5013L14 12.4234L8.13598 6.86304L14 1.30423L12.8632 0.224792L6.9992 5.78512L1.13679 0.224792L0 1.30423L5.86241 6.86304L0 12.4218L1.13679 13.5013L6.9992 7.94095Z"
                      fill="currentColor" />
            </svg>
        </button>

        <button class="reset-btn file-input-group__open" @click.prevent="toggleBox"
                :class="{ 'is-selected': boxVisible }">
            <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.4 2.26707H7.66875L5.46938 0.0435975C5.44139 0.0159086 5.40458 0.000347387 5.36625 0H0.6C0.268125 0 0 0.283384 0 0.634146V12.3659C0 12.7166 0.268125 13 0.6 13H14.4C14.7319 13 15 12.7166 15 12.3659V2.90122C15 2.55046 14.7319 2.26707 14.4 2.26707Z"
                    fill="currentColor" />
            </svg>
        </button>

        <button class="reset-btn file-input-group__notification" @mouseenter="toggleLinkNotification" @mouseleave="toggleLinkNotification"
                :class="{ 'is-selected': linkNotification }">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 9H12.01M11 12H12V16H13M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z" stroke="#575F6E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                />
            </svg>
        </button>

        <div class="link-notification__wrapper">
            <div class="link-notification"
                :class="{ 'visible': linkNotification, 'hidden': !linkNotification }">
                <div class="link-notification__header">
                    Ссылка на файл
                </div>
                <div class="link-notification__text">
                    После загрузки файл будет доступен по ссылке.
                    Чтобы получить ссылку  нажмите на
                    <svg width="24" height="24" focusable="false">
                        <path d="M6.2 12.3a1 1 0 0 1 1.4 1.4l-2 2a2 2 0 1 0 2.6 2.8l4.8-4.8a1 1 0 0 0 0-1.4 1 1 0 1 1 1.4-1.3 2.9 2.9 0 0 1 0 4L9.6 20a3.9 3.9 0 0 1-5.5-5.5l2-2Zm11.6-.6a1 1 0 0 1-1.4-1.4l2-2a2 2 0 1 0-2.6-2.8L11 10.3a1 1 0 0 0 0 1.4A1 1 0 1 1 9.6 13a2.9 2.9 0 0 1 0-4L14.4 4a3.9 3.9 0 0 1 5.5 5.5l-2 2Z" fill-rule="nonzero"></path>
                    </svg><br>
                    в текстовом редакторе. Далее выберите нужный файл во всплывающем окне:
                    <picture>
                        <img src="/images/link_notification_img.png" alt="Пример выбора ссылки">
                    </picture>
                </div>
            </div>
        </div>
    </div>

    <div class="file-upload box mt-1" v-show="boxVisible">
        <button class="reset-btn box__close" @click.prevent="toggleBox">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.9992 7.94095L12.8616 13.5013L14 12.4234L8.13598 6.86304L14 1.30423L12.8632 0.224792L6.9992 5.78512L1.13679 0.224792L0 1.30423L5.86241 6.86304L0 12.4218L1.13679 13.5013L6.9992 7.94095Z"
                      fill="currentColor" />
            </svg>
        </button>
        <!-- Загрузка из локального источника -->
        <div class="file-upload__local-title" v-show="!cloud">Загрузите файл с устройства</div>
        <div class="file-upload__dropzone">
            <div class="file-upload__dropzone-text">
                <button class="choose reset-btn" v-on:click.stop.prevent="uploadFileFromInputLocal">Выберите файлы</button>
                <p>Максимальный размер файла {{this.max_file_upload_size}}</p>
            </div>
            <input class="file-upload__local-input" type="file" ref="files" name="" id="" :multiple="multiple_property" v-on:change="uploaded">
        </div>
        <div class="file-upload__local-btn-wrap" v-show="!cloud">
            <button v-on:click="uploadFile()" class="file-upload-btn reset-btn">Загрузить</button>
        </div>
        <!-- /Загрузка из локального источника  -->
    </div>

    <div v-if="documents" class="file-upload__files-list">
        <table class="align-middle w-auto">
            <tbody>
            <tr v-for="file in documents">
                <td class="py-1">
                    <a :href="file.value" class="text-decoration-none">{{ file.title }}</a>
                </td>
                <td>
                    <div>
                        <button @click="removeDocument(file.id)" class="table-action table-action_delete align-middle me-sm-1 mx-md-1 mx-lg-2"></button>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <Alert />
</template>

<script>
import Error from '../../components/alerts/Error.vue';
import Alert from '../../components/alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'DocumentationFileUploadElement',
    components: {
			Alert,
		},
    props: {
        multiple_property: {
            type: Boolean,
            default: true
        },
        picture_path: {
            type: String,
            default: ''
        },
        article_id: Number,
        valid_file_size: Number,
        max_file_upload_size: String,
        route_get_documents: String
    },
    data: function() {
        return {
            cloud: false,
            picked_file: undefined,
            boxVisible: false,
            linkNotification: false,
            fileNames: [],
            documents: [],
            formData: {
                file: [],
            },
        }
    },
    emits: [
        'fileUpload'
    ],
    computed: {
        file: function () {
            return this.picked_file
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        uploadFile: async function () {

            this.files = this.$refs.files.files;

            if (!this.files.length) {
                // alert('Выберите файлы');
                this.alertMessage = 'Выберите файлы'
                this.showWarning()
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите файлы' });
                return;
            }

            if (!this.maxFilesSize()) {
                return;
            }

            let formData = new FormData();

            formData.append('article_id', this.article_id);

            for(let i = 0; i < this.files.length; i++){
                let file = this.files[i];
                formData.append('files[' + i + ']', file);
            }

            axios.post('/docs/upload/file', formData).then(
                response => {
                    if (response.data.status == 'ok') {
                        this.addAlert({ type: 'success', title: 'Успешно', text: 'Успешно загружено!' });
                        this.getDocuments();
                        this.boxVisible = false;
                        this.clearInput();
                    } else {
                        this.addAlert({ type: 'error', title: 'Ошибка', text: response.data.message });
                    }
                });
        },
        maxFilesSize: function () {
            const maxBytes = this.valid_file_size;
            const maxMb = (maxBytes / (1024 * 1024));

            for (let file of this.files) {
                if (file.size > maxBytes) {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: `Файл «${file.name}» больше допустимого размера (${maxMb} МБ)` });
                    return false;
                }
            }
            return true;
        },
        uploaded: function (e) {
            if(e.target.files.length > 0)
            {
                this.picked_file = '';
                this.fileNames = [];
                for (let i = 0; i < e.target.files.length; i++) {
                    let file = e.target.files.item(i);
                    this.fileNames.push(file.name);

                    this.picked_file = this.picked_file ? `${this.picked_file} ${file.name}` : file.name;
                    this.$emit('fileUpload', file);
                }
            }
        },
        getDocuments: async function () {
            this.documents = [];
            let documents = await axios.get(this.route_get_documents, {
                params: {
                    id: this.article_id
                }
            });
            for (let i = 0; i < documents.data.length; i++) {
                if (documents.data[i].id != undefined) {
                    this.documents.push(documents.data[i]);
                }
            }
        },
        removeDocument: function (id) {
            let confirmation = confirm('Удалить файл?');
            if (!confirmation) {
                return;
            }
            if (confirmation) {
                axios.delete('/documentation/remove/document', {
                    params: {
                        id: id,
                    }
                }).then(() => {
                    this.getDocuments();
                });
            }
        },
        uploadFromCloud() {
            this.cloud = true
        },
        uploadFromLocal() {
            this.cloud = false
        },
        uploadFileFromInputLocal(e) {
            let fileInput = e.currentTarget.closest('.file-upload__dropzone').querySelector('.file-upload__local-input') || false
            fileInput.click()
            //При клике на кнопку "Выберите файл" открываем скрытй файл-инпут, из которого дальше сможем передать файлы в formData
        },
        clearInput(e) {
            //Сбрасываем адрес в инпуте наверху
            // e.currentTarget.closest('.file-input-group').querySelector('.file-input-group__input').value = '';
            this.picked_file = undefined;
            this.$emit('fileUpload', false);
            if(this.picture_path === false) {
                this.boxVisible = true;
            }
        },
        toggleBox() {
            //Переключаем видимость модалки
            this.boxVisible = !this.boxVisible
        },
        toggleLinkNotification() {
            //Переключаем видимость модалки
            this.linkNotification = !this.linkNotification
        },
        fileUpload: function (e) {
            if (e) {
                this.formData.file.push(e);
            }

            if (!e) {
                this.formData.file = [];
            }
        },
        //Остаётся добавить обработчики событий на кнопки Загрузить
    },
    mounted () {
        this.getDocuments();
    }
}
</script>
<style scoped lang="scss">
@keyframes fadeIn{
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes fadeOut{
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
.visible {
    animation-name: fadeIn;
    animation-duration: 0.3s;
    display: flex;
}

.hidden {
    animation-name: fadeOut;
    animation-duration: 0.3s;
    display: none;
}

.file-input-group {
    display: flex;
    align-items: stretch;
    max-width: 526px;

    @media screen and (max-width: 767px) {
        max-width: unset;
    }

    &__input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    &__reset,
    &__open {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        color: #A8A8A8;
        border: 1px solid #D1D1D1;
        border-left: none;
        transition: 50ms ease-in-out color;

        &:hover,
        &:focus-visible {
            outline: none;
            color: #0095D6;;
        }

        &:active {
            color: #45C7FF;
        }
    }

    &__open.is-selected {
        color: #0095D6;
    }

    &__notification {
        position: relative;
        padding: 0px 8px;
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        color: transparent;
        transition: 50ms ease-in-out color;
        cursor: help;

        &:hover,
        &:focus-visible {
            outline: none;
            svg path {
                stroke: #0095D6;
            }
        }

        &:active {
            svg path {
                stroke: #45C7FF;
            }
        }
    }

    &__notification.is-selected {
        svg path {
            stroke: #0095D6;
        }
    }

    &__reset {
        width: 35px;
    }

    &__open {
        width: 39px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
}

.link-notification {
    position: absolute;
    top: -69px;
    left: 10px;
    background-color: #fff;
    border-color: #eee;
    border-radius: 10px;
    border-style: solid;
    border-width: 0;
    box-shadow: 0 16px 16px -10px rgba(34,47,62,.15),
    0 0 40px 1px rgba(34,47,62,.15);
    // display: flex;
    flex-direction: column;
    max-height: 235px;
    width: 277px;
    z-index: 10;

    &__wrapper {
        position: relative;
    }

    &__header {
        padding: 15px;
        font-size: 14px;
        line-height: 16px;
        font-weight: 600;
    }
    &__text {
        padding: 0px 15px 15px 15px;
        font-size: 12px;
        line-height: 18px;
        img {
            margin-top: 10px;
        }
    }
    &::before {
        content: '';
        position: absolute;
        bottom: 50%;
        left: -10px;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-bottom: 10px solid transparent;
        border-left: 10px solid transparent;
        border-right: 15px solid rgb(255, 255, 255);
        border-top: 10px solid transparent;
        // box-shadow: 0 16px 16px -10px rgba(34,47,62,.15),
        //             0 0 40px 1px rgba(34,47,62,.15);
        z-index: 999;
    }
}

.file-upload {
    grid-template-columns: 188px auto;
    grid-template-rows: max-content max-content max-content;
    gap: 20px;
    max-width: 488px;

    @media screen and (max-width: 767px) {
        max-width: unset;
    }

    @media screen and (max-width: 575px) {
        grid-template-columns: 95px auto;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }

    &__ctrls {
        grid-column: 1;
        grid-row: 1/3;

        @media screen and (max-width: 575px) {
            grid-row: 1;
        }
    }

    &__ya-title,
    &__local-title {
        font-weight: 600;
        font-size: 16px;
        text-align: center;

        @media screen and (max-width: 767px) {
            font-size: 12px;
        }
    }

    &__ya-title {
        grid-column: 2;
        grid-row: 1;
    }

    &__local-title {
        display: none;

        @media screen and (max-width: 575px) {
            display: block;
            text-align: left;
        }
    }

    &__dropzone {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        grid-column: 2;
        grid-row: 1/4;
        padding: 10px;
        border: 1px dashed #A8A8A8;
        border-radius: 5px;
        min-height: 100px;
        cursor: auto;

        @media screen and (max-width: 575px) {
            grid-row: 2;
            grid-column: 1/3;
            padding: 0;
            min-height: unset;
            border: none;
        }
    }

    &__ya-link {
        grid-column: 2;
        grid-row: 2;

        @media screen and (max-width: 575px) {
            grid-column: 1/3;
        }
    }

    &__ya-up-btn-wrap {
        grid-column: 2;
        grid-row: 3;

        @media screen and (max-width: 575px) {
            display: flex;
            justify-content: center;
            grid-column: 1/3;
        }
    }

    &__ctrl {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 46px;
        padding: 10px;
        cursor: pointer;
        border-radius: 3px;
        background-color: #FBFBFB;
        color: #333333;
        font-size: 16px;
        letter-spacing: 0.01em;
        line-height: 1.5;
        transition: 50ms ease-in-out background-color;

        @media screen and (max-width: 767px) {
            padding: 7px 10px;
            font-size: 12px;
            min-height: 33px;
        }

        &:hover {
            background-color: #ECECEC;
        }

        &.is-selected {
            background-color: #ECECEC;
        }

        &:not(:last-child) {
            margin-bottom: 1px;
        }
    }

    &__ya-link-label {
        margin-bottom: 10px;
        font-size: 16px;

        @media screen and (max-width: 767px) {
            margin-bottom: 7px;
            font-size: 12px;
        }
    }

    &__local-btn-wrap {
        display: flex;
        align-items: flex-end;
        grid-column: 1;
        grid-row: 3;
        margin-top: inherit;

        @media screen and (max-width: 575px) {
            display: flex;
            justify-content: center;
            grid-column: 1/3;
        }
    }

    &__dropzone-text {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        line-height: 1.5;
        letter-spacing: 0.01em;
        color: #333333;

        .drop-files {
            margin-bottom: 14px;
            font-size: 18px;
            font-weight: 600;
            text-transform: uppercase;
        }

        .or {
            margin-bottom: 14px;
            font-size: 16px;
            text-transform: uppercase;
        }

        .choose {
            padding: 9px 28px;
            font-size: 16px;
            color: #A8A8A8;
            border-radius: 5px;
            border: 1px solid #00D515;
            text-transform: uppercase;
            cursor: pointer;
            transition: 50ms ease-in-out color;

            &:hover {
                color: #333333;
            }
        }

        @media screen and (max-width: 575px) {
            width: 100%;

            .drop-files,
            .or {
                display: none;
            }

            .choose {
                padding: 12px;
                width: 100%;
                font-size: 14px;
                text-transform: none;
            }
        }
    }

    &__local-input {
        position: absolute;
        margin-left: -1px;
        width: 1px;
        height: 1px;
        clip-path: inset(2px);
    }

    &__files-list {
        padding: 8px 0px;
        max-width: 480px;
    }
}

.file-upload-btn {
    font-size: 16px;
    color: #00D515;
    text-align: left;
}
</style>
